import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTIONS} from '../../../../constants/paginator';
import {TestResultsTableComponent} from '../../../components/tables/test-results-table/test-results-table.component';
import {TestResultsDataSource} from '../../../data/source/TestResultsDataSource';
import {TestResultService} from '../../../services/api/result/test-result.service';
import {TestResultFilters} from '../../../data/models/filters/test-result-filters';
import {TestResultsExportDialogComponent} from '../../../components/dialogs/test-results-export-dialog/test-results-export-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Test} from '../../../data/models/test/test';
import {TestService} from '../../../services/api/test.service';
import {MeService} from '../../../services/api/me.service';
import {TEST_RESULT_PRIVILEGES} from '../../../../constants/privileges';

@Component({
  selector: 'app-test-results-page',
  templateUrl: './test-results-page.component.html',
  styleUrls: ['./test-results-page.component.css']
})
export class TestResultsPageComponent implements OnInit, AfterViewInit {

  readonly PRIVILEGES = TEST_RESULT_PRIVILEGES;
  readonly pageSizeOptions = PAGE_SIZE_OPTIONS;
  readonly displayedColumns = [
    'id', 'studentName', 'studentMail', 'isTelegram', 'startDate',
    'finishDate', 'checkDate', 'points', 'percent'];

  @ViewChild(TestResultsTableComponent) testResultsTable!: TestResultsTableComponent;

  testId?: number;
  test?: Test;
  filters: TestResultFilters = {
    isFinished: 'true',
  };
  dataSource: TestResultsDataSource;
  sort: string[] = ['finishDate', 'desc'];
  pageSize = PAGE_SIZE_DEFAULT;
  pageNumber = 0;

  get queryParams(): object {
    return {
      ...this.filters,
      sort: this.sort,
      size: this.pageSize,
      number: this.pageNumber,
    };
  }

  canExport = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private meService: MeService,
    private testService: TestService,
    private testResultService: TestResultService,
  ) {
    this.dataSource = new TestResultsDataSource(this.testResultService);
    this.canExport = this.meService.hasPrivilege(this.PRIVILEGES.READ);
  }

  ngOnInit(): void {
    const testId = +(this.route.snapshot.paramMap.get('testId') || 0);
    if (testId) {
      this.testId = testId;
      this.testService.getTest(testId)
        .then(test => {
          this.test = test;
        });
    }
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length === 0) {
        this.router.navigate([], {
          replaceUrl: true,
          queryParams: this.queryParams,
        });
      } else {
        this.setFilters({
          search: params.search,
          isFinished: params.isFinished,
          isChecked: params.isChecked,
        });
        this.setSort(params.sort);
        this.setPage(params.size, params.number);
        this.loadData();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.testResultsTable.sort$.subscribe(sort => {
        this.setSort([sort.active, sort.direction]);
        this.navigate();
      });
      this.testResultsTable.page$.subscribe(event => {
        this.setPage(event.pageSize, event.pageIndex);
        this.navigate();
      });
    }, 0);
  }

  loadData(): void {
    if (this.testId) {
      this.dataSource.loadTestResults({
        testId: this.testId,
        ...this.filters,
      }, this.sort, this.pageSize, this.pageNumber);
    }
  }

  setFilters(filters: TestResultFilters): void {
    this.filters = filters;
  }

  setSort(sort: string[]): void {
    if (Array.isArray(sort) && sort.length === 2) {
      this.sort = sort;
    }
  }

  setPage(pageSize: number, pageNumber: number): void {
    pageSize = +pageSize;
    pageNumber = +pageNumber;
    if (Number.isInteger(pageSize) && pageSize > 0) {
      this.pageSize = pageSize;
    }
    if (Number.isInteger(pageNumber) && pageNumber >= 0) {
      this.pageNumber = pageNumber;
    }
  }

  onFiltersChange(filters: TestResultFilters): void {
    if (filters.search === this.filters.search &&
      filters.isFinished === this.filters.isFinished &&
      filters.isChecked === this.filters.isChecked) {
      this.loadData();
    } else {
      this.setFilters(filters);
      this.setPage(this.pageSize, 0);
      this.navigate();
    }
  }

  navigate(): void {
    this.router.navigate([], {
      queryParams: this.queryParams,
    });
  }

  openTestResultsExportDialog(): void {
    this.dialog.open(TestResultsExportDialogComponent, {
      data: {
        test: this.test
      }
    });
  }

}
